<template>
    <div class="flex items-center">
        <!-- Enabled: "bg-indigo-600", Not Enabled: "bg-gray-200" -->
        <button
            type="button"
            :name="name"
            class="bg-gray-200 relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            :class="this.enabled ? 'bg-green-600' : 'bg-gray-200'"
            aria-pressed="false"
            aria-labelledby="annual-billing-label"
            @click="toggle"
        >
            <span class="sr-only">Use setting</span>
            <!-- Enabled: "translate-x-5", Not Enabled: "translate-x-0" -->
            <span
                aria-hidden="true"
                class="translate-x-0 pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"
                :class="this.enabled ? 'translate-x-5' : 'translate-x-0'"
            >
            </span>
        </button>
        <span class="ml-3" id="annual-billing-label">
            <slot></slot>
        </span>
    </div>
</template>

<script>
export default {

    model: {
        prop: 'checked',
        event: 'input'
    },

    props: ['checked', 'name'],

    data() {
        return {
            enabled: this.checked
        }
    },

    methods: {
        toggle() {
            this.enabled = !this.enabled;
            this.$emit('change', {target: {name: this.name}})
            this.$emit('input', this.enabled)
        }
    }

}
</script>

<style scoped>

.toggle-checkbox:checked {
    @apply right-0 border-green-400;
    right: 0;
    border-color: #68D391;
}

.toggle-checkbox:checked + .toggle-label {
    @apply bg-green-400;
    background-color: #68D391;
}

</style>
